// src/pages/DrawingPhase.jsx
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import TarotCard from '../components/TarotCard';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const shuffleDeck = (deck) => {
  let shuffled = [...deck];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const DrawingPhase = ({ spread, onDrawComplete }) => {
  const deckCards = useSelector((state) => state.tarot.cards);
  const [cardsToDisplay, setCardsToDisplay] = useState([]);
  const [drawnCards, setDrawnCards] = useState([]);
  const [flippedCardIds, setFlippedCardIds] = useState([]);
  const [isCompleting, setIsCompleting] = useState(false);

  useEffect(() => {
    const shuffled = shuffleDeck(deckCards);
    const selected = shuffled.slice(0, 15);
    setCardsToDisplay(selected);

    // Precargar imágenes para que se vean al instante al voltear
    selected.forEach((card) => {
      if (card.image) {
        const img = new Image();
        img.src = card.image;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectCard = (card) => {
    if (drawnCards.length >= spread.cards || flippedCardIds.includes(card.id) || isCompleting) return;
    const newCard = { ...card, isReversed: Math.random() < 0.3 };
    const newDrawnCards = [...drawnCards, newCard];
    setDrawnCards(newDrawnCards);
    setFlippedCardIds((prev) => [...prev, card.id]);
    if (newDrawnCards.length === spread.cards) {
      setIsCompleting(true);
      // Dar tiempo para ver las cartas antes de avanzar
      setTimeout(() => onDrawComplete(newDrawnCards), 3500);
    }
  };

  const remaining = spread.cards - drawnCards.length;

  return (
    <div className="page-container">
      <div className="drawing-header">
        <h2 className="page-title font-cinzel">Selecciona tus Cartas</h2>
        <p className="page-subtitle">
          {isCompleting
            ? '✨ Las cartas han sido elegidas. El Oráculo se prepara...'
            : `Elige ${remaining} carta${remaining !== 1 ? 's' : ''} más, guiándote por tu intuición.`}
        </p>
      </div>

      {/* Progress */}
      <div className="drawing-progress">
        {Array.from({ length: spread.cards }).map((_, i) => (
          <div
            key={i}
            className={`progress-dot ${i < drawnCards.length ? 'progress-dot--filled' : ''}`}
          >
            {i < drawnCards.length ? '✦' : '○'}
          </div>
        ))}
      </div>

      {/* Cards grid */}
      {cardsToDisplay.length > 0 ? (
        <div className="drawing-area">
          {cardsToDisplay.map((card) => {
            const isSelected = flippedCardIds.includes(card.id);
            // Mostrar la carta con isReversed si ya fue seleccionada
            const drawnVersion = drawnCards.find((c) => c.id === card.id);
            const displayCard = drawnVersion || card;
            return (
              <div
                key={card.id}
                className={`drawing-card-slot ${isSelected ? 'drawing-card-slot--selected' : ''} ${drawnCards.length >= spread.cards && !isSelected ? 'drawing-card-slot--inactive' : ''}`}
              >
                <TarotCard
                  card={displayCard}
                  isFlipped={isSelected}
                  onFlip={() => handleSelectCard(card)}
                  showLabel={isSelected}
                />
              </div>
            );
          })}
        </div>
      ) : (
        <LoadingSpinner message="Preparando el mazo..." />
      )}

      {isCompleting && (
        <div className="completing-overlay">
          <LoadingSpinner message="El Oráculo está leyendo las energías..." />
        </div>
      )}
    </div>
  );
};

export default DrawingPhase;
